// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "container-OwB7n";
var _4 = "header-3tOk3";
var _5 = "description-32WwL";
var _6 = "row-2pfCM";
var _7 = "main-2uhMq";
var _8 = "field_comment-3JCZM";
var _9 = "field-2SqSo";
var _a = "controls-34qnj";
var _b = "submit-3sM1b";
var _c = "button-3yRot";
var _d = "button_checked-39DBF";
var _e = "warningModal-nQey2";
var _f = "label-xR5As";
export { _1 as "__esModule", _2 as "mobile", _3 as "container", _4 as "header", _5 as "description", _6 as "row", _7 as "main", _8 as "field_comment", _9 as "field", _a as "controls", _b as "submit", _c as "button", _d as "button_checked", _e as "warningModal", _f as "label" }
export default { "__esModule": _1, "mobile": _2, "container": _3, "header": _4, "description": _5, "row": _6, "main": _7, "field_comment": _8, "field": _9, "controls": _a, "submit": _b, "button": _c, "button_checked": _d, "warningModal": _e, "label": _f }
